"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _group = require("@/api/_homeCloudPlatform/group/group.js");
var _memberManage = require("@/api/_homeCloudPlatform/member/memberManage.js");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _file = require("@/api/file");
var _region = require("@/api/region");
var _mixin = _interopRequireDefault(require("@/views/_homeCloudPlatform/mall/mixin.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO
// const formModel = {
//   enclosure: [],
//   type: "1"
// }

// const phoneValidator = (rule, value, callBack) => {
//   const reg = /^[1][0-9]{10}$/
//   if (value) {
//     if (!reg.test(value)) {
//       callBack('请输入正确的联络人手机号')
//     } else {
//       callBack()
//     }
//   } else {
//     callBack()
//   }
// }
var formModel = {
  group_status: 0,
  group_type: 1,
  top_b_status: false,
  province_code: '',
  city_code: '',
  district_code: ''
  // members: [{name:""}],
};
var _default = exports.default = {
  mixins: [_mixin.default],
  components: {
    Pagination: _Pagination.default
  },
  computed: {
    rules: function rules() {
      var _this = this;
      return {
        group_name: [{
          required: true,
          message: '请输入机构名称',
          trigger: 'blur'
        }],
        top_b_status: [{
          required: true,
          message: '请选择合作伙伴类型',
          trigger: 'blur'
        }],
        group_type: [{
          required: true,
          message: '请选择类型',
          trigger: 'blur'
        }],
        group_identifier: [{
          required: true,
          message: '请输入统一社会信用代码(18位)',
          trigger: 'blur'
        }, {
          max: 18,
          message: '输入长度不能超过18位'
        }, {
          min: 18,
          message: '输入长度不能小于18位'
        }],
        group_owner: [{
          required: true,
          message: '请输入经营者名称',
          trigger: 'blur'
        }],
        group_operator_phone: [{
          required: true,
          message: '请输入11位会员帐号(手机号)',
          trigger: 'blur'
        }],
        device_type: [{
          required: true,
          message: '请选择设备类型',
          trigger: 'change'
        }],
        location: [{
          validator: function validator(rule, value, callBack) {
            // TODO 验证,网址规则
            if (!_this.formModel.province_code || !_this.formModel.city_code || !_this.formModel.district_code) {
              callBack('请选择完整服务省区市');
            } else {
              callBack();
            }
          },
          trigger: 'submit'
        }],
        // file_path: [
        //   { required: true, message: '请输入固件档案阿里云地址', trigger: 'blur' },
        //   { max: 150, message: '输入长度不能超过150位' },
        //   { validator: (rule, value, callBack) => {
        //     // TODO 验证,网址规则
        //     // if (value) {
        //     //   callBack('多笔请使用「,」分隔')
        //     // } else {
        //     callBack()
        //     // }
        //   }, trigger: 'submit'
        //   }
        // ],
        address: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'blur'
        }],
        service_content: [{
          required: true,
          message: '请输入服务项目',
          trigger: 'blur'
        }]
        // name: { required: true, validator: (rule, value, callBack) => {
        //   if(value){
        //     let arr = []
        //     // 找重复
        //     this.formModel.members.forEach((item, i) => {
        //       if(item.name && value.name === item.name)
        //         arr.push(item.name)
        //     })
        //     if(arr.length > 1){
        //       callBack('健康管理师名字重复')
        //     }else if(value.mobile || value.wechat){
        //       if(!value.name){
        //         callBack('请输入名字')
        //         }
        //       else callBack()
        //     }else{
        //       callBack()
        //     }
        //   }else{
        //     callBack()
        //   }
        // }},
        // mobile: { required: true, validator: (rule, value, callBack) => {
        //   if(value){
        //     let arr = []
        //     // 找重复
        //     this.formModel.members.forEach(item => {
        //       if(item.mobile && value.mobile === item.mobile)
        //         // console.log('item.mobile:'+item.mobile)
        //         arr.push(item.mobile)
        //     })
        //     // console.log('arr:'+arr)
        //     if(arr.length > 1 ){
        //       callBack('手机号重复')
        //     }else if(value.name || value.wechat){
        //       if(!value.mobile){
        //         callBack('请输入手机号')
        //         }
        //       else callBack()
        //     }else{
        //       callBack()
        //     }
        //   }else{
        //     callBack()
        //   }
        // }},     
        // wechat: { required: true, validator: (rule, value, callBack) => {
        //   if(value){
        //     let arr = []
        //     // 找重复
        //     this.formModel.members.forEach(item => {
        //       if(item.wechat && value.wechat === item.wechat)
        //         arr.push(item.wechat)
        //     })
        //     if(arr.length > 1){
        //       callBack('健康管理师wechat重复')
        //     }else if(value.mobile || value.name){
        //       if(!value.wechat){
        //         callBack('请输入wechat')
        //         }
        //       else callBack()
        //     }else{
        //       callBack()
        //     }
        //   }else{
        //     callBack()
        //   }
        // }},  
      };
    },
    dialogTitle: function dialogTitle() {
      var type = '';
      switch (this.dialogType) {
        case 'view':
          type = '查看';
          break;
        case 'add':
          type = '新增';
          break;
        case 'edit':
          type = '编辑';
          break;
      }
      return "".concat(type, "\u5408\u4F5C\u673A\u6784");
    }
  },
  watch: {
    dialogType: {
      immediate: true,
      handler: function handler(val) {
        this.disabled = val !== 'edit' && val !== 'add';
      }
    }
  },
  data: function data() {
    return {
      formModel: formModel,
      previewImg: '',
      // 默认排序,依创建时间递减
      defaultOrdering: '-created_at',
      // formModel : {
      //   group_name: '',
      //   group_status: 0,
      //   group_type: 1,
      //   // group_identifier: '',
      //   group_license: '',
      //   province_code: '',
      //   city_code: '',
      //   district_code: '',
      //   address: '',
      //   service_content: '',
      //   group_operator: null,
      // },
      ownerName: '',
      withdraw_bank: '',
      withdraw_account: '',
      withdraw_bank_branch: '',
      withdraw_bank_account: '',
      // formModel,
      disabled: false,
      tableData: {},
      listLoading: true,
      listQuery: {
        page: 1,
        page_size: 20
        // group_status: 1,
        // group_type: 1
      },
      dialogVisible: false,
      dialogType: 'view',
      // 图片 / 档案 API
      upHeaders: (0, _file.upHeaders)(),
      upUrl: (0, _file.upUrl)(),
      // 状态选项
      statusOptions: [{
        key: 'all',
        display_name: '全部'
      }, {
        key: 1,
        display_name: '已认证'
      }, {
        key: 0,
        display_name: '未认证'
      }],
      // 类型选项
      typeOptions: [{
        key: 'all',
        display_name: '全部'
      }, {
        key: 1,
        display_name: '个人'
      }, {
        key: 2,
        display_name: '公司法人'
      }],
      // 合作伙伴类型（是否为大B）
      bTypeOptions: [{
        key: 'all',
        display_name: '全部'
      }, {
        key: false,
        display_name: 'B端合作伙伴'
      }, {
        key: true,
        display_name: '大客户'
      }],
      // B端合作伙伴Level(改读取api)
      // group_level: [
      //   { key: "level_1", display_name: 'Level 1' },
      //   { key: "level_2", display_name: 'Level 2' },
      //   { key: "level_3", display_name: 'Level 3' },
      //   { key: "level_4", display_name: 'Level 4' },
      //   { key: "level_5", display_name: 'Level 5' },
      // ],
      provinceData: [],
      cityData: [],
      defaultCity: [],
      districtData: [],
      defaultDistrict: [],
      province_code: '',
      city_code: '',
      district_code: '',
      groupLevelOptions: []
    };
  },
  created: function created() {
    this.getList();
    this.getProvinceAll();
    this.getCityAll();
    this.getDistrictAll();
    this.getGroupLevelList();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _group.getGroupList)(this.handleQuery()).then(function (response) {
        if (response.results) {
          _this2.tableData = response || [];
        }
        console.log('getGroupList res', response);
        _this2.listLoading = false;
      });
    },
    getGroupLevelList: function getGroupLevelList() {
      var _this3 = this;
      (0, _group.getGroupLevelList)({
        page: 1,
        page_size: 1,
        group_level_status: 1
      }).then(function (data) {
        if (!data.count) return;
        (0, _group.getGroupLevelList)({
          page_size: data.count,
          group_level_status: 1
        }).then(function (res) {
          _this3.groupLevelOptions = res.results || [];
          console.log('groupLevelOptions', _this3.groupLevelOptions);
        });
      });
    },
    handleQuery: function handleQuery() {
      var query = (0, _objectSpread2.default)({}, this.listQuery);
      // 状态
      if (query.group_status === '' || query.group_status === 'all') {
        query.group_status = function () {
          return;
        }();
      }
      // 类型
      if (query.group_type === '' || query.group_type === 'all') {
        query.group_type = function () {
          return;
        }();
      }
      // 合作伙伴类型
      if (query.top_b_status === '' || query.top_b_status === 'all') {
        query.top_b_status = function () {
          return;
        }();
      }
      console.log('handleQuery', query);
      return query;
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: this.listQuery.page_size
      };
      this.getList();
    },
    handleAdd: function handleAdd() {
      this.formModel = JSON.parse(JSON.stringify(formModel));
      this.handleInitData();
      this.dialogType = 'add';
      this.dialogVisible = true;
    },
    handleView: function handleView(scope) {
      var _this4 = this;
      // TODO 记得要填入对应资料
      this.formModel = Object.assign({}, scope.row);
      this.handleInitData();
      // this.tableData.results[0] = this.formModel
      this.ownerName = this.formModel.group_operator_name;
      this.dialogType = 'view';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this4.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this5 = this;
      // TODO 记得要填入对应资料
      this.formModel = Object.assign({}, scope.row); // copy obj
      // if (this.formModel.members.length==0) {
      //   this.formModel.members = [{name: ""}]
      // }
      this.handleInitData();
      this.ownerName = this.formModel.group_operator_name;
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this5.$refs['Form'].clearValidate();
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(form) {
        var _this6 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this6.dialogType === 'edit';
                  delete _this6.formModel.group_operator_phone;
                  if (_this6.ownerName == '') {
                    _this6.$message({
                      message: '请输入正确会员帐号(手机号)',
                      type: 'warning'
                    });
                    return false;
                  }
                  if (_this6.previewImg.path) {
                    _this6.formModel.group_license = _this6.previewImg.path;
                  } else {
                    delete _this6.formModel.group_license;
                  }
                  // if(this.formModel.members[0].name =='') {
                  //   this.formModel.members = []
                  // }

                  if (isEdit) {
                    (0, _group.updateGroupList)(_this6.formModel.id, _this6.formModel).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this6.errorHandle(res);
                      }
                      _this6.getList();
                      _this6.dialogVisible = false;
                      _this6.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else {
                    (0, _group.createGroupList)(_this6.formModel).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this6.errorHandle(res);
                      }
                      _this6.getList();
                      _this6.dialogVisible = false;
                      _this6.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var _this7 = this;
      var isLt2M = file.size / 1024 / 1024 < 0.5;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 500kb!');
      } else {
        var reader = new FileReader();
        reader.onload = function (e) {
          // 打API上传图片
          var formdata = new FormData();
          formdata.append('file', file);
          (0, _group.createGroupImage)(formdata).then(function (res) {
            _this7.previewImg = {
              // image: e.target.result, //直接读取
              urls: "".concat(res.data.urls),
              //从API res读取
              path: "".concat(res.data.path)
            };
          });
        };
        reader.readAsDataURL(file);
      }
      return isLt2M;
    },
    removeImg: function removeImg() {
      this.previewImg = {};
      this.formModel.group_license = '';
    },
    handleDelete: function handleDelete(scope) {
      var _this8 = this;
      return;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return deleteDoctor(scope.row.id);
            case 2:
              _this8.getList();
              _this8.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    getName: function getName() {
      var _this9 = this;
      if (this.formModel.group_operator_phone.length == 11) {
        var listQuery = {
          page: 1,
          page_size: this.listQuery.page_size,
          account: this.formModel.group_operator_phone
        };
        (0, _memberManage.getUsersList)(listQuery).then(function (response) {
          if (response.results.length > 0) {
            _this9.ownerName = response.results[0].name;
            _this9.withdraw_bank = response.results[0].withdraw_bank;
            _this9.withdraw_account = response.results[0].withdraw_account;
            _this9.withdraw_bank_account = response.results[0].withdraw_bank_account;
            _this9.withdraw_bank_branch = response.results[0].withdraw_bank_branch;
            _this9.formModel.group_operator = response.results[0].id;
          } else {
            _this9.$message({
              message: '请输入正确会员帐号(手机号)',
              type: 'warning'
            });
          }
          _this9.listLoading = false;
          // })
        });
      } else {
        this.$message({
          message: '请输入11位会员帐号(手机号)',
          type: 'warning'
        });
      }
    },
    getProvinceAll: function getProvinceAll() {
      var _this10 = this;
      (0, _region.getProvinceAll)().then(function (response) {
        _this10.provinceData = response.data;
      });
    },
    provinceChange: function provinceChange(val) {
      var _this11 = this;
      this.cityData = [];
      // this.org.city_code = ''
      // this.org.district_code = ''
      this.defaultCity.forEach(function (item) {
        var item_city = Object.assign({}, item);
        _this11.cityData.push(item_city);
      });
      var province_code = this.provinceData.filter(function (item) {
        return item.province_code === val;
      })[0].province_code;
      this.cityData = this.cityData.filter(function (item) {
        return item.province_code === province_code;
      });
    },
    getCityAll: function getCityAll() {
      var _this12 = this;
      (0, _region.getCityAll)().then(function (response) {
        _this12.defaultCity = response.data;
        _this12.cityData = [];
        _this12.defaultCity.forEach(function (item) {
          var item_city = Object.assign({}, item);
          _this12.cityData.push(item_city);
        });
      });
    },
    cityChange: function cityChange(val) {
      var _this13 = this;
      this.districtData = [];
      // this.org.district_code = ''
      this.defaultDistrict.forEach(function (item) {
        var item_district = Object.assign({}, item);
        _this13.districtData.push(item_district);
      });
      var city_code = this.cityData.filter(function (item) {
        return item.city_code === val;
      })[0].city_code;
      this.districtData = this.districtData.filter(function (item) {
        return item.city_code === city_code;
      });
    },
    getDistrictAll: function getDistrictAll() {
      var _this14 = this;
      (0, _region.getDistrictAll)().then(function (response) {
        _this14.defaultDistrict = response.data;
        _this14.districtData = [];
        _this14.defaultDistrict.forEach(function (item) {
          var item_district = Object.assign({}, item);
          _this14.districtData.push(item_district);
        });
      });
    },
    // 初始化资料处理
    handleInitData: function handleInitData() {
      var _this15 = this;
      this.previewImg = {};
      // 图片
      this.previewImg = {
        urls: this.formModel.group_license_url
      };
      this.ownerName = '';
      if (this.formModel.group_operator_phone && this.formModel.group_operator_phone.length == 11) {
        var listQuery = {
          page: 1,
          page_size: this.listQuery.page_size,
          account: this.formModel.group_operator_phone
        };
        (0, _memberManage.getUsersList)(listQuery).then(function (response) {
          if (response.results.length > 0) {
            _this15.ownerName = response.results[0].name;
            _this15.withdraw_bank = response.results[0].withdraw_bank;
            _this15.withdraw_account = response.results[0].withdraw_account;
            _this15.withdraw_bank_account = response.results[0].withdraw_bank_account;
            _this15.withdraw_bank_branch = response.results[0].withdraw_bank_branch;
            _this15.formModel.group_operator = response.results[0].id;
          }
        });
      }
    },
    handleDisabled: function handleDisabled() {
      var isDisabled = true;
      // 非新增情况下，类型都不支持变更
      if (this.dialogType != 'add') {
        isDisabled = true;
      } else {
        isDisabled = false;
      }
      return isDisabled;
    },
    handleSort: function handleSort(column) {
      // 初始化处理
      if (!column) {
        this.listQuery.ordering = this.listQuery.ordering || this.defaultOrdering;
        return {
          prop: this.defaultOrdering.indexOf('-') !== -1 ? this.defaultOrdering.split('-')[1] : this.defaultOrdering,
          order: this.defaultOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 点击排序
      else {
        this.listQuery.page = 1;
        this.listQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrdering;
        this.getList();
      }
    } // addMember() {
    //   this.formModel.members.push({name: ""})
    // },
    // deleteMember(item) {
    //   this.formModel.members.splice(this.formModel.members.indexOf(item), 1)
    //   this.$nextTick(() => {
    //     // this.$refs['Form'].clearValidate()
    //     this.formModel.members.forEach( (item,index) => {
    //       this.$refs['Form'].validateField(`members.${index}`)
    //     })
    //   })
    // },
  }
};